import { DrugFoodInteraction, RequestBatchResult } from "domain/entities/drug-food-interaction";
import { DrugFoodInteractionRepository } from "domain/repositories";

export default class CreateBatchUseCase {
    private drugFoodInteractionRepository: DrugFoodInteractionRepository;
    
    public constructor(drugFoodInteractionRepository: DrugFoodInteractionRepository) {
        this.drugFoodInteractionRepository = drugFoodInteractionRepository
    }

    public async createDrugFoodInteractionBatch(drugFoodInteraction: DrugFoodInteraction[], token: Promise<[string | null, string | null]>): Promise<[RequestBatchResult, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.drugFoodInteractionRepository.createDrugFoodInteractionBatch(drugFoodInteraction, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}